import Pages from "enums/Pages";
import { Sliders } from "react-feather";
import { useTranslation } from "react-i18next";
import { FC, useEffect, useState } from "react";
import FlowDashboardFilter from "./FlowDashboardFilter";
import InnerPageLayout from "layouts/InnerPageLayout";
import DefaultPageLayout from "layouts/DefaultPageLayout";
import CapturedVehicleGraphs from "./CapturedVehicleGraphs";
import { dateToString } from "utils/DateFunctions";
import { usePageLocation } from "contexts/PageLocationContext";
import {
  FlowDashboardFilterProvider,
  useFlowDashboardFilter
} from "./FlowDashboardFilterContext";
import PageSection from "components/PageSection/PageSection";
import PageSectionHeaderAction from "components/PageSection/PageSectionHeaderAction";

const FlowDashboardContent: FC = () => {
  const { t } = useTranslation();
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const { filterData } = useFlowDashboardFilter();

  const dateTitle =
    filterData.startDate && filterData.endDate
      ? `(${dateToString(filterData.startDate, "dd/MM/yyyy")} - ${dateToString(
          filterData.endDate,
          "dd/MM/yyyy"
        )})`
      : "";

  return (
    <PageSection
      title={`${t("FlowDashboardPage.flowDashboard")} ${dateTitle}`}
      primaryActions={
        <PageSectionHeaderAction
          variant="contained"
          color="secondary"
          startIcon={<Sliders />}
          onClick={() => setIsFilterOpen(true)}
        >
          {t("action.filter")}
        </PageSectionHeaderAction>
      }
    >
      <FlowDashboardFilter open={isFilterOpen} setOpen={setIsFilterOpen} />
      <CapturedVehicleGraphs />
    </PageSection>
  );
};

const FlowDashboardPage: FC = () => {
  const { t } = useTranslation();
  const { setPageTitle, setLocation } = usePageLocation();

  useEffect(() => {
    setPageTitle(t("windowTitle.flowDashboard"));
    setLocation([
      {
        label: t("FlowDashboardPage.flowDashboard"),
        page: Pages.FLOW_DASHBOARD
      }
    ]);
  }, [t, Pages]);

  return (
    <DefaultPageLayout>
      <InnerPageLayout>
        <FlowDashboardFilterProvider>
          <FlowDashboardContent />
        </FlowDashboardFilterProvider>
      </InnerPageLayout>
    </DefaultPageLayout>
  );
};

export default FlowDashboardPage;
